import React from "react"
import PropTypes from "prop-types"
import { OverlayTrigger, PopOver } from "@tencent/spaui"

class MpOpenInfo extends React.Component {
  static propTypes = {
    mpOpenName: PropTypes.string,
  }

  render() {
    const { mpOpenName } = this.props
    if (!mpOpenName) {
      return null
    }

    return (
      <OverlayTrigger
        placement="bottom"
        alignment="left"
        overlay={
          <PopOver>
            <img src={`https://open.weixin.qq.com/qr/code?username=${mpOpenName}`} alt={mpOpenName} style={{ width: "100%", height: "100%" }} />
          </PopOver>
        }
      >
        <span className={"MpOpenInfo"}>
          {mpOpenName} <i className="fas fa-qrcode"></i>
        </span>
      </OverlayTrigger>
    )
  }
}

export default MpOpenInfo
